import type React from "react";

import { CheckboxIcon } from "@similarweb/ui-components";

import type { TechnologiesDDItemType } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";

import { StyledItemContainer, StyledItemCheckbox, StyledPlainTooltip } from "./styles";

export type DropdownWithTabsItemProps = {
    item: TechnologiesDDItemType;
    itemHeight?: number;
    onClick(): void;
    renderText(item: TechnologiesDDItemType): React.ReactNode;
    isSingleSelect?: boolean;
    tooltipForDisabledItem?: string;
};

const DropdownWithTabsItem = (props: DropdownWithTabsItemProps) => {
    const { item, itemHeight, onClick, renderText, isSingleSelect, tooltipForDisabledItem } = props;

    const ddContent = (
        <>
            {renderText(item)}
            <StyledItemCheckbox>
                {isSingleSelect ? null : (
                    <CheckboxIcon
                        selected={item.isSelected}
                        disabled={item.isDisabled}
                    />
                )}
            </StyledItemCheckbox>
        </>
    );
    if (item.isDisabled) {
        const disabledContainer = (
            <StyledItemContainer
                isDisabled={item.isDisabled}
                itemHeight={itemHeight}
                data-automation="dd-item"
            >
                {ddContent}
            </StyledItemContainer>
        );

        if (tooltipForDisabledItem) {
            return (
                <StyledPlainTooltip
                    tooltipContent={tooltipForDisabledItem}
                    enabled={true}
                    cssClass="plainTooltip-element technologies-dd-tooltip"
                >
                    <div data-automation="disabled-dd-item">{disabledContainer}</div>
                </StyledPlainTooltip>
            );
        }

        return disabledContainer;
    }

    return (
        <StyledItemContainer
            onClick={onClick}
            itemHeight={itemHeight}
            data-automation="dd-item"
        >
            {ddContent}
        </StyledItemContainer>
    );
};

export default DropdownWithTabsItem;
